// Corsac data layer. Liquid (snippets/cx-data.liquid) fills window.CX_DATA with the shop settings, routes, product texts
// and the products this page needs; the rest of the catalogue loads from /collections/all?view=cx-json when needed.
(function () {
  const CX = (window.CX = window.CX || {});
  const D = window.CX_DATA || {};

  CX.site = D.site || {};
  CX.routes = Object.assign({
    home: '/', shop: '/collections/all', account: '/account', search: '/search',
    about: '/pages/about', contact: '/pages/contact', faq: '/pages/faq', returns: '/pages/refund-policy', terms: '/pages/terms-conditions',
    product: (id) => '/products/' + encodeURIComponent(id),
    collection: (slug) => '/collections/' + (slug || 'all'),
  }, D.routes || {});
  const root = (D.routes && D.routes.root) || '/';
  CX.routes.product = (id) => root + 'products/' + encodeURIComponent(id);
  CX.routes.collection = (slug) => root + 'collections/' + (slug || 'all');
  CX.productTexts = D.texts || {};
  CX.cardOptions = Object.assign({ hover: true, quickView: true, sizes: true, stars: true }, D.cards || {});
  CX.motionOptions = Object.assign({ smooth: true, reveal: true }, D.motion || {});
  CX.asset = (path) => (D.assetBase || '') + String(path).split('/').pop();

  // Shopify image URLs carry width=; swap it for the size we want (or add one).
  CX.img = (url, w) => {
    if (!url) return '';
    if (!/\/cdn\/shop\//.test(url) || !w) return url;
    return /[?&]width=\d+/.test(url) ? url.replace(/([?&]width=)\d+/, `$1${w}`) : url + (url.includes('?') ? '&' : '?') + 'width=' + w;
  };
  CX.srcset = (url, widths = [360, 540, 720, 960, 1200]) => (/\/cdn\/shop\//.test(url || '') ? widths.map((w) => `${CX.img(url, w)} ${w}w`).join(', ') : '');
  CX.money = (n) => 'Rs ' + Math.round(Number(n)).toLocaleString('en-PK');

  /* ---------- Catalogue ---------- */
  let catalogue = [];
  const byId = new Map();
  const tidy = (p) => {
    if (!p.variants || p.variants.length < 2) p.variants = null;
    p.cats = p.cats || [];
    p.sizes = p.sizes || [];
    p.sold = p.sold || [];
    p.gallery = (p.gallery || []).filter(Boolean);
    p.img = p.gallery[0] || '';
    return p;
  };
  CX.addProducts = (list) => {
    (list || []).forEach((p) => {
      if (!p || !p.id) return;
      const known = byId.get(p.id);
      // Keep the richer copy (product pages send the full description, size chart and every photo).
      if (known && (known.full || !p.full) && known.gallery.length >= (p.gallery || []).length) return;
      const q = tidy({ ...p });
      byId.set(q.id, q);
      if (known) catalogue[catalogue.indexOf(known)] = q; else catalogue.push(q);
    });
    CX.catalogue = catalogue;
    CX.products = catalogue.filter((p) => p.listed !== false).sort((a, b) => (a.pos || 9999) - (b.pos || 9999));
  };
  CX.byId = (id) => byId.get(id);
  // Sections list the products they show in <script type="application/json" data-cx-seed> blocks.
  CX.readSeeds = (root = document) => root.querySelectorAll('script[data-cx-seed]').forEach((el) => {
    try { CX.addProducts(JSON.parse(el.textContent)); } catch (e) { /* malformed seed: skip it */ }
  });
  CX.addProducts(D.products || []);
  CX.readSeeds();
  CX.catalogueComplete = Boolean(D.complete);
  let loading = null;
  CX.loadCatalogue = () => {
    if (CX.catalogueComplete) return Promise.resolve();
    loading = loading || fetch(root + 'collections/all?view=cx-json', { credentials: 'same-origin' })
      .then((r) => r.json())
      .then((list) => {
        CX.catalogueComplete = true;
        CX.addProducts(list);
        // Colour siblings only count while they are on the store.
        catalogue.forEach((p) => { if (p.variants) { p.variants = p.variants.filter(([id]) => byId.has(id)); if (p.variants.length < 2) p.variants = null; } });
        document.dispatchEvent(new CustomEvent('cx:catalogue'));
      })
      .catch(() => { loading = null; });
    return loading;
  };
  if (!CX.catalogueComplete) {
    // The rest of the catalogue loads after the first tap, scroll or key press, ready before search or quick look opens.
    const kick = () => {
      ['pointerdown', 'keydown', 'scroll', 'touchstart'].forEach((t) => window.removeEventListener(t, kick));
      (window.requestIdleCallback || ((cb) => setTimeout(cb, 200)))(() => CX.loadCatalogue());
    };
    ['pointerdown', 'keydown', 'scroll', 'touchstart'].forEach((t) => window.addEventListener(t, kick, { passive: true }));
  }
  CX.photo = (id, n = 0) => {
    const p = CX.byId(id);
    return p ? p.gallery[Math.min(n, p.gallery.length - 1)] : '';
  };

  /* ---------- Product helpers ---------- */
  CX.isSold = (p, size) => (p.sold || []).includes(size);
  CX.firstSize = (p) => (p.sizes || []).find((s) => !CX.isSold(p, s)) || (p.sizes || [])[0] || '';
  CX.badge = (p) => (!p.inStock ? 'Sold out' : p.compare ? Math.round((1 - p.price / p.compare) * 100) + '% OFF' : '');
  CX.excerpt = (p, max = 150) => {
    const text = String(p.desc || '').replace(/<\/p>[\s\S]*/, '').replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim();
    return text.length > max ? text.slice(0, max).replace(/\s+\S*$/, '') + '…' : text;
  };
  const COLOUR_WORDS = ['white', 'off', 'black', 'blue', 'navy', 'brown', 'dark', 'light', 'grey', 'gray', 'beige', 'cream', 'green', 'mint', 'olive', 'red', 'burgundy', 'maroon', 'pink', 'tan', 'khaki', 'charcoal', 'sand', 'rust', 'taupe', 'ivory', 'lavender', 'dusty', 'dusk', 'powder', 'sky', 'teal', 'cherry', 'forest', 'ash', 'indigo', 'stripe', 'orange', 'yellow', 'purple', 'camel', 'stone', 'sage'];
  CX.variantLabel = (p) => ((p.variants || []).every(([, label]) => String(label).toLowerCase().split(/\s+/).every((w) => COLOUR_WORDS.includes(w))) ? 'Colour' : 'Style');

  // Product types by role: breadcrumbs (Liquid) and "Complete the look" use the same grouping as the live theme.
  CX.categories = [
    { name: 'T-Shirts', cats: ['T-Shirts'] },
    { name: 'Hoodies', cats: ['Hoodies', 'Hoodies | Sweatshirts'] },
    { name: 'Knitwear', cats: ['Knitwears', 'Polo Shirts', 'Jumpers & Cardigans'] },
    { name: 'Shirts', cats: ['Shirts', 'Resort shirt'] },
    { name: 'Trousers', cats: ['Trousers', 'Cargo pants', 'Cargos & Sweatpants', 'Shorts'] },
    { name: 'Jeans', cats: ['Jeans', 'Baggy Jeans'] },
    { name: 'Jackets', cats: ['Jackets'] },
    { name: 'Leather Goods', cats: ['Leather Travel Bags', 'Belts & Wallets'] },
    { name: 'Fragrances', cats: ['Fragrances'] },
  ];
  CX.categoryOf = (p) => CX.categories.find((c) => c.cats.includes(p.type));
  const ROLES = { top: ['T-Shirts', 'Hoodies', 'Knitwear', 'Shirts'], outer: ['Jackets'], bottom: ['Trousers', 'Jeans'], acc: ['Leather Goods', 'Fragrances'] };
  const roleOf = (p) => { const c = CX.categoryOf(p); return c ? Object.keys(ROLES).find((r) => ROLES[r].includes(c.name)) : null; };
  const NEXT = { top: ['bottom', 'outer', 'acc'], outer: ['top', 'bottom'], bottom: ['top', 'outer', 'acc'], acc: ['acc', 'top'] };
  const shuffle = (list) => { const a = [...list]; for (let i = a.length - 1; i > 0; i--) { const j = Math.floor(Math.random() * (i + 1)); [a[i], a[j]] = [a[j], a[i]]; } return a; };
  // Complete the look: the product's own picks (vulpes.look); otherwise, unless switched off in the product page
  // settings, up to 3 random in-stock pieces of the same gender, one per complementary role, then other kinds.
  CX.pairsFor = (p) => {
    const curated = (p.look || []).filter((id) => id !== p.id).map(CX.byId).filter(Boolean).slice(0, 4);
    if (curated.some((q) => q.inStock)) return curated.filter((q) => q.inStock);
    if (CX.productTexts.bundleAuto === false) return [];
    const siblings = (p.variants || []).map(([id]) => id);
    const gender = ['Men', 'Women'].filter((g) => p.cats.includes(g));
    const fits = (q) => !gender.length || !['Men', 'Women'].some((g) => q.cats.includes(g)) || gender.some((g) => q.cats.includes(g));
    const pool = shuffle(CX.products.filter((q) => q.id !== p.id && !siblings.includes(q.id) && q.inStock && fits(q)));
    const picked = [];
    (NEXT[roleOf(p)] || ['top', 'bottom']).forEach((role) => {
      const q = pool.find((x) => roleOf(x) === role && !picked.includes(x));
      if (q && picked.length < 3) picked.push(q);
    });
    const own = roleOf(p);
    pool.forEach((q) => { if (picked.length < 3 && !picked.includes(q) && (!own || roleOf(q) !== own)) picked.push(q); });
    return picked;
  };
  // You may also like: same type first, then anything sharing a category tag.
  CX.relatedFor = (p, n = 8) => {
    const others = CX.products.filter((o) => o.id !== p.id);
    const sameType = others.filter((o) => o.type === p.type);
    const shared = others.filter((o) => o.type !== p.type && o.cats.some((c) => p.cats.includes(c)));
    const rest = others.filter((o) => !sameType.includes(o) && !shared.includes(o));
    return [...sameType, ...shared, ...rest].slice(0, n);
  };
})();
